/**
 * ClassificacaoTemplate — regras de pontuação por indicador/campo de página, filhas de Template.
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import Classificacao from '../../../models/Classificacao';
import TemplateModel from '../../../models/Template';
import TemplateCampoModel from '../../../models/TemplateCampo';
import { buildRelacionados } from '../../../service/RotasService';
import ClassificacaoTipoEnum from '../../../enums/ClassificacaoTipoEnum';
import IndicadorEnum from '../../../enums/IndicadorEnum';

const modelSchema = {
  descricao: { exibir: 'main.classificacao.descricao', visivel: true, validacao: { obrigatorio: true } },
  tipo: { exibir: 'main.classificacao.tipo', visivel: true, tipo: 'enum', entidade: 'classificacao.tipo' },
  indicador: { exibir: 'main.classificacao.indicador', visivel: true, tipo: 'enum', entidade: 'indicador' },
  monitoramentotemplate: {
    exibir: 'main.classificacao.monitoramentotemplate',
    visivel: true,
    tipo: 'relacao',
    camporelacao: 'descricao',
    entidade: 'monitoramentotemplate.entidade',
    template: 'monitoramentotemplate.template',
    validacao: { obrigatorio: true },
  },
  monitoramentotemplatecampo: {
    exibir: 'main.classificacao.monitoramentotemplatecampo',
    tipo: 'relacao',
    camporelacao: 'nome',
    entidade: 'monitoramentotemplatecampo.entidade',
    template: 'monitoramentotemplatecampo.template',
  },
  ativo: { exibir: 'main.classificacao.ativo', visivel: true, tipo: 'boolean' },
  template: { exibir: 'main.classificacao.template', visivel: true, validacao: { obrigatorio: true } },
  peso: { exibir: 'main.classificacao.peso', visivel: true, tipo: 'numeric', keyfilter: 'num', validacao: { obrigatorio: true } },
};

const renderers = {
  'classificacao.tipo': ClassificacaoTipoEnum,
  indicador: IndicadorEnum,
  'monitoramentotemplate.entidade': TemplateModel,
  'monitoramentotemplate.template': (rowData) => rowData.monitoramentotemplate?.descricao || '',
  'monitoramentotemplatecampo.entidade': TemplateCampoModel,
  'monitoramentotemplatecampo.template': (rowData) => rowData.monitoramentotemplatecampo?.nome || '',
};

class ClassificacaoFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.classificacao.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.descricao} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelDropDown model={model.tipo} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelDropDown model={model.monitoramentotemplate} contexto={contexto} /></div>
            {model.tipo?.value?.id === 'main.classificacaomonitoramentotemplate.tipo.templatecampo' ? (
              <div className="field col-12 mt-3"><ModelDropDown model={model.monitoramentotemplatecampo} contexto={contexto} /></div>
            ) : (
              <div className="field col-12 mt-3"><ModelDropDown model={model.indicador} contexto={contexto} /></div>
            )}
            <div className="field col-12 mt-3"><ModelTextInput model={model.template} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelInputNumber model={model.peso} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelBoolean model={model.ativo} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class ClassificacaoTemplate extends Component {
  render() {
    return (
      <EntityGrid
        entidade={Classificacao}
        model={modelSchema}
        identidade="main.classificacao"
        permissoes={this.props.permissoes}
        icone="pi-star"
        storageKey="dt-classificacoes"
        getRelacionados={(selected) => buildRelacionados('classificacao', this.props.permissoes, this.props.navigate, () => selected?.[0])}
        renderers={renderers}
        configuracao={this.props.configuracao}
        navigate={this.props.navigate}
        location={this.props.location}
        searchparams={this.props.searchparams}
        formulario={(m, ctx) => <ClassificacaoFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default ClassificacaoTemplate;
